import { Box, Button, Stack, Typography, Tooltip, Grid2, Accordion, AccordionSummary, AccordionDetails, Skeleton } from '@mui/material';
import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { Icon } from '@iconify/react';
import FloorCard from './FloorCard';
import { useGetProjectQuery } from 'api/project/queries/useGetProjectQuery';
import { useGetProjectFloorsQuery } from 'api/project/queries/useGetProjectFloors';
import { useWorkspaces } from 'contexts/WorkspacesContext';
import { Floor } from 'utils/floor';
import Lottie from 'react-lottie-player';
import ErrorAnimation from "assets/lotties/error.json";
import LoadingAnimation from "assets/lotties/loading.json";
import { checkAccess } from 'utils/userAccess';
import AddFloorModal from 'containers/FloorplanAlignment/components/AddFloorModal';
import { useAtom } from 'jotai';
import { newFloorModalOpenAtom } from 'store/atoms/floorplanAlignment/layersAtom';
import { staffVisionEnabledAtom } from 'store/atoms/staff/staffAtoms';
import JSONPretty from 'react-json-pretty';
import JSONAccordion from 'components/JSONAccordion/JSONAccordion';

export default function Floors() {
  const { projectSlug = '' } = useParams();
  const { activeWorkspace } = useWorkspaces();

  const [newFloorModalOpen, setNewFloorModalOpen] = useAtom(newFloorModalOpenAtom);
  const [staffVisionEnabled] = useAtom(staffVisionEnabledAtom)

  const { data: project, isPending: isProjectPending } = useGetProjectQuery(projectSlug, activeWorkspace.id);
  const { data: floors, isPending: isFloorsPending } = useGetProjectFloorsQuery(project?.id || "")

  return (
    <Box sx={{ p: 3 }}>
      <Stack direction="row" spacing={1} alignItems="center" mb={3} justifyContent="space-between" width="100%">
        <Stack direction="row" spacing={1} alignItems="center">
          <Link to=".." relative="path" style={{ textDecoration: 'none' }}>
            <Typography
              sx={{
                fontWeight: '600',
                fontSize: '1.25rem',
                letterSpacing: '-2%',
                color: '#777',
                transition: 'all .2s ease',
                ':hover': {
                  color: 'white',
                },
              }}
            >
              {project?.name}
            </Typography>
          </Link>
          <Icon icon="icon-park-outline:right" color="#aaa" />
          <Typography
            sx={{
              fontWeight: '600',
              fontSize: '1.25rem',
              letterSpacing: '-2%',
            }}
          >
            Floors
          </Typography>
        </Stack>
        <Stack direction="row" spacing={1}>
          {checkAccess("ADMIN", activeWorkspace.role) && (
            <Button
              variant="contained"
              onClick={() => setNewFloorModalOpen(true)}
              sx={{
                background: 'royalblue',
                color: 'white',
                fontWeight: 600,
                ':hover': {
                  background: 'royalblue',
                  opacity: 0.9,
                },
              }}
            >
              Add Floor
            </Button>
          )}
          {false && checkAccess("ADMIN", activeWorkspace.role) && (
            <Link
              to={`/${activeWorkspace.slug}/${projectSlug}/floorplan-alignment`}
              relative="route"
              style={{ textDecoration: 'none' }}
            >
              <Button
                variant="contained"
                sx={{
                  background: 'royalblue',
                  color: 'white',
                  fontWeight: 600,
                  ':hover': {
                    background: 'royalblue',
                    opacity: 0.9,
                  },
                }}
              >
                Align Floorplans
              </Button>
            </Link>)}
        </Stack>
      </Stack>

      {staffVisionEnabled && (
        <JSONAccordion data={floors} />
      )}

          {/* (!floors || floors.length === 0) ? ( */}
            {/* <Box sx={{
              // display: 'flex', 
              //   flexDirection: 'column', 
              //   alignItems: 'center',
              display: 'grid',
              placeItems: 'center',
              // justifyContent: 'center',
              padding: '2rem',
              height: '100%',
              gap: "1.5rem"
            }}>
              <Lottie
                play
                style={{ width: "20rem", height: "20rem" }}
                animationData={ErrorAnimation}
              />
              <Typography textAlign="center" variant="h3">
                No floors available
              </Typography>
            </Box>
          ) : ( */}
            <Grid2 container spacing={3} size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
              {isProjectPending || isFloorsPending ? (
                Array.from({ length: 4 }).map((_, index) => (
                  <Skeleton
                    variant="rectangular"
                    width={"12rem"}
                    height={"12rem"}
                    sx={{
                      borderRadius: "8px",
                    }}
                  />
                ))
              ) : floors?.map((floor: Floor) => (
                <FloorCard floor={floor} key={floor.id} />
              ))}
            </Grid2>

      <AddFloorModal />
    </Box>
  );
}